const c = 6, o = /^(\d+)(\s*-\s*\d+)?\s*(Werktage|Tage)$/i;
function f(e, t = void 0, r = !1) {
  if (e === void 0) return;
  let i = "Verfügbar";
  return t && t.match(o) && t.match(/\d+/g)?.map(Number)?.every((a) => a < 5) && (i = "Sofort verfügbar"), e >= 6 ? {
    key: "InStock",
    modifier: "in-stock",
    text: i,
    deliveryTime: t
  } : e >= 1 ? {
    key: "LimitedAvailability",
    modifier: "limited-availability",
    text: "Wenige verfügbar",
    deliveryTime: t
  } : {
    key: "OutOfStock",
    modifier: "out-of-stock",
    text: r ? "In Kürze verfügbar" : "Aktuell leider vergriffen",
    deliveryTime: t
  };
}
function u(e, t = !1) {
  if (e === void 0) return;
  const r = e.stock || 0, i = e.deliveryLeadTime?.text || void 0;
  return f(r, i, t);
}
export {
  c as MIN_STOCK_FOR_FULL_STOCK,
  f as availability,
  u as calculateAvailability
};
